import * as DG from 'datagrok-api/dg';
import { SeqPaletteBase } from './seq-palettes';
import { getMonomerLibHelper } from './types/monomer-library';
import { PolymerTypes } from './helm/consts';
/** makes the color less white, makes the transparency effect always perceptible
 * @param {string} color color in string format either hex or rgb.
 * @param {boolean} scale if scale is needed to 210 brightness.
 * @return {string} color in rgb format.
 * */
function correctColor(color, scale = true) {
    if (color == null)
        return 'rgb(100,100,100)';
    const dgColor = DG.Color.fromHtml(color);
    if (scale) {
        const g = DG.Color.g(dgColor);
        const r = DG.Color.r(dgColor);
        const b = DG.Color.b(dgColor);
        // calculate euclidean distance to white
        const distToBlack = Math.sqrt(Math.pow(0 - r, 2) + Math.pow(0 - g, 2) + Math.pow(0 - b, 2));
        // normalize vector r g b
        const normR = r / distToBlack;
        const normG = g / distToBlack;
        const normB = b / distToBlack;
        if (distToBlack > 210)
            return `rgb(${normR * 210},${normG * 210},${normB * 210})`;
    }
    return DG.Color.toRgb(dgColor);
}
export class StringUtils {
    static hashCode(s) {
        let hash = 0;
        if (s.length === 0)
            return hash;
        for (let i = 0; i < s.length; i++) {
            const chr = s.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
}
export class UnknownSeqPalette {
}
export class GrayAllPalette extends UnknownSeqPalette {
    get(_m, _polymerType) {
        return '#666666';
    }
}
export class UnknownColorPalette extends UnknownSeqPalette {
    static get palette() {
        if (!UnknownColorPalette._pallete)
            UnknownColorPalette._pallete = UnknownColorPalette.buildPalette();
        return UnknownColorPalette._pallete;
    }
    static buildPalette() {
        getMonomerLibHelper().then((lh) => {
            lh.awaitLoaded(Infinity).then(() => {
                const monLib = lh.getMonomerLib();
                monLib.onChanged.subscribe(() => {
                    UnknownColorPalette.customMonomerColors = {};
                    UnknownColorPalette.polymerTypes = monLib.getPolymerTypes();
                    for (const polymerType of this.polymerTypes) {
                        const monomerSymbols = monLib.getMonomerSymbolsByType(polymerType);
                        for (const monomerSymbol of monomerSymbols) {
                            const monomer = monLib.getMonomer(polymerType, monomerSymbol);
                            if (monomer?.meta?.colors?.default?.background) {
                                if (!this.customMonomerColors[monomerSymbol])
                                    this.customMonomerColors[monomerSymbol] = {};
                                this.customMonomerColors[monomerSymbol][polymerType] =
                                    correctColor(monomer.meta.colors.default.background);
                            }
                        }
                    }
                });
            });
        });
        const res = [].concat(...Object.values(SeqPaletteBase.colourPalette));
        return res;
    }
    get(m, polymerType) {
        const palleteLength = UnknownColorPalette.palette.length;
        const colorObj = UnknownColorPalette.customMonomerColors[m];
        const polType = polymerType ?? PolymerTypes.PEPTIDE;
        if (colorObj && colorObj[polType])
            return colorObj[polType];
        const hash = StringUtils.hashCode(m);
        const pI = hash % palleteLength;
        return correctColor(UnknownColorPalette.palette[pI]);
    }
}
UnknownColorPalette._pallete = null;
// this way is just more future-proof, when we start distinguishing
// between different polymer types for coloring of non natural aa's or nucleotides
UnknownColorPalette.customMonomerColors = {};
UnknownColorPalette.polymerTypes = [];
export class UnknownSeqPalettes extends SeqPaletteBase {
    static get Gray() {
        if (this.gray === void 0)
            this.gray = new GrayAllPalette();
        return this.gray;
    }
    static get Color() {
        if (this.color === void 0)
            this.color = new UnknownColorPalette();
        return this.color;
    }
}
//# sourceMappingURL=unknown.js.map